export default "__VITE_ASSET__Kiq3blWT__"